import { Validators } from "@angular/forms";
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants";
import { IFormKey } from "src/app/modules/shared/models/forms";
import { IPolicyAsset } from "src/app/modules/shared/models/policy.model";
import { IGianosDatiOperatore, IGianosDesignazioneBeneficiari, IGianosEsecutoreConto, IGianosOperationInfo, IGianosPaymentMode, IGianosPolicyHolder, IGianosPolicyInsured, IGianosTitolareEffettivo } from "../../isv.constants";

export const isv_partial_redeem_form_template = {
    iban: null,
    amount: null,
    fiscalRegime: null,
    type: null
}

export const isv_partial_redeem_form_validators = {
    iban: [Validators.required],
    amount: [Validators.required]
}

export const isv_partial_redeem_form_keys: IFormKey[] = [
    {
        id: 'iban-field',
        label: 'Coordinate bancarie',
        controlName: 'iban',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'amount-field',
        label: 'Importo lordo da liquidare',
        controlName: 'amount',
        css: 'col-4',
        isAmountField: true
    },
]

export const isv_partial_redeem_selective_radio: IFormKey = {
    id: 'type-field',
    label: 'Modifica fondi',
    controlName: 'type',
    type: 'TOGGLE',
    css: 'col-4'
}

export const RISPA_ISP_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'description',
        label: 'Nome fondo'
    },
    {
        key: 'fundAmount',
        label: 'Importo fondo (€)'
    },
    {
        key: 'amount',
        label: 'Importo da disinvestire (€)'
    }
];

export interface IIsvRiscattoParzialeRequest {
    policyNumber: string;
    contraente: IGianosPolicyHolder;
    assicurato: IGianosPolicyInsured;
    polizzaOperazione: IGianosOperationInfo;
    operatoreContraente: IGianosDatiOperatore;
    esecutoreConto?: IGianosEsecutoreConto;
    designazioneBeneficiario?: IGianosDesignazioneBeneficiari[];
    titolareEffettivi?: IGianosTitolareEffettivo[];
    paymentMode: IGianosPaymentMode;
    fundsList?: IPolicyAsset[];
    isFinalized: string;
    ndgTutoreODelegato: string;
    codiceLineaCompagnia?: string[];
    controvaloreLineaCompagnia?: string[];
    consultancyAmount: string;
    redemptionType?: string;
    taxRegime?: string;
    operationPurpose?: string;
    describeExtraData?: any;
}
